import { createSelector } from 'reselect';
import { actionTypes } from '../actions';

// Constants (down)

export const moduleName = 'categories';

export const CATEGORY_LEVELS = {
  SECTORS: 'sectors',
  CATEGORIES: 'categories',
  SERVICES: 'services',
};

/**
 *
 * @param {string} currentLevel
 *
 * @return {string|null}
 */
export function getNextCategoryLevel(currentLevel) {
  const levelsAsValues = Object.values(CATEGORY_LEVELS);

  if (levelsAsValues.includes(currentLevel)) {
    const currentLevelIndex = levelsAsValues.indexOf(currentLevel);

    return levelsAsValues[currentLevelIndex + 1] || null;
  }

  return null;
}

// Constants (up)

// Reducer (down)

const initialState = {
  fetched: false,
  fetching: false,
  entities: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.CATEGORIES_FETCH_REQUEST:
      return {
        ...state,
        fetched: false,
        fetching: true,
        entities: initialState.entities,
      };

    case actionTypes.CATEGORIES_FETCH_SUCCESS: {
      const { categories } = payload;

      return {
        ...state,
        fetched: true,
        fetching: false,
        entities: [...categories],
      };
    }

    case actionTypes.CATEGORIES_FETCH_FAILURE:
      return {
        ...state,
        fetched: false,
        fetching: false,
        entities: [],
      };

    default:
      return state;
  }
};

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectCategoriesFetched = createSelector(
  stateSelector, (categories) => categories.fetched,
);

export const selectCategories = createSelector(
  stateSelector, (categories) => categories.entities,
);

export const selectCategoriesByLevels = createSelector(
  selectCategories,
  (entities) => {
    const categoriesByLevels = Object.values(CATEGORY_LEVELS).reduce(
      (result, currentLevel) => ({
        ...result,
        [currentLevel]: [],
      }),
      {},
    );

    entities.forEach((sector) => {
      categoriesByLevels[CATEGORY_LEVELS.SECTORS].push({ ...sector });

      sector.childs.forEach((category) => {
        categoriesByLevels[CATEGORY_LEVELS.CATEGORIES].push({ ...category });

        category.childs.forEach((service) => {
          categoriesByLevels[CATEGORY_LEVELS.SERVICES].push({ ...service });
        });
      });
    });

    return categoriesByLevels;
  },
);

export const selectCategoriesServices = createSelector(
  selectCategoriesByLevels,
  (categoriesByLevels) => categoriesByLevels[CATEGORY_LEVELS.SERVICES] || [],
);

export const selectCategoriesServiceTagsToNames = createSelector(
  selectCategoriesServices,
  (services) => services.reduce((result, { name, tag }) => ({
    ...result,
    [tag]: name,
  }), {}),
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/categories.js